import styled from "styled-components";

const SIDEBAR_W = "200px";

export const Layout = styled.div`
  display: flex;
  min-height: 100vh;
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const Main = styled.main`
  margin-left: ${SIDEBAR_W};
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 14px 32px;
  background: #fff;
  border-bottom: 1px solid #e0e8f0;
`;

export const AddButton = styled.button`
  padding: 8px 20px;
  border-radius: 20px;
  border: 1.5px solid #26A9B6;
  background: #fff;
  color: #26A9B6;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover { background: #f0fbfc; }
`;

export const Content = styled.div`
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 1.6rem;
  font-weight: 700;
  color: #1b3a6b;
  white-space: nowrap;
`;

export const TabsRow = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`;

export const Tab = styled.button`
  padding: 6px 18px;
  border-radius: 20px;
  border: none;
  background: ${({ $active }) => ($active ? "#1b3a6b" : "transparent")};
  color: ${({ $active }) => ($active ? "#fff" : "#666")};
  font-size: 0.85rem;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  cursor: pointer;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: ${({ $active }) => ($active ? "#1b3a6b" : "#dce8f0")};
    color: ${({ $active }) => ($active ? "#fff" : "#1b3a6b")};
  }
`;

export const ActivityPanel = styled.div`
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.07);
  padding: 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
`;

export const TypeIconWrap = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #edf6f9;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #2c7a8a;
`;

export const TypeInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

export const TypeName = styled.h2`
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #1b3a6b;
`;

export const TypeSubtitle = styled.p`
  margin: 0;
  font-size: 0.82rem;
  color: #888;
`;

export const SelectedCounter = styled.span`
  font-size: 0.78rem;
  font-weight: 700;
  color: #999;
  white-space: nowrap;
  letter-spacing: 0.04em;
`;

export const ActivitiesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
`;

export const ActivityCard = styled.div`
  border: 2px solid ${({ $selected }) => ($selected ? "#26A9B6" : "#e8eef4")};
  border-radius: 10px;
  padding: 14px 16px;
  background: ${({ $selected }) => ($selected ? "#f0fbfc" : "#fff")};
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;

  &:hover {
    border-color: #26A9B6;
  }
`;

export const CardTop = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const Checkbox = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 4px;
  border: 2px solid ${({ $checked }) => ($checked ? "#26A9B6" : "#ccd6de")};
  background: ${({ $checked }) => ($checked ? "#26A9B6" : "#fff")};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.15s;
`;

export const CardName = styled.h3`
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1b3a6b;
  flex: 1;
`;

export const EditIconBtn = styled.button`
  background: none;
  border: none;
  padding: 2px;
  cursor: pointer;
  color: #aab4be;
  display: flex;
  align-items: center;
  flex-shrink: 0;

  &:hover { color: #26A9B6; }
`;

export const TagsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const Tag = styled.span`
  padding: 3px 10px;
  border-radius: 12px;
  background: #edf6f9;
  color: #2c7a8a;
  font-size: 0.75rem;
  font-weight: 500;
`;

export const CardDescription = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: #777;
  line-height: 1.5;
`;

export const LoadingMsg = styled.p`
  color: #999;
  font-size: 0.9rem;
  text-align: center;
  padding: 32px 0;
`;
